module.exports = __webpack_public_path__ + "static/media/2004-iphone-icon.a5853ff9.png";